export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/singers_vocalists.b7d3c41.svg";